import { Button, css, styled } from 'canoe';

import { ValueInput } from '@candu-ai/craft/ui';

export const InlineMessage = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: ${theme.spaces.xs};
  `}
`;

export const SelectorInputWrapper = styled.div`
  ${({ theme }) => css`
    margin: ${theme.spaces.xs} 0;
    position: relative;
  `}
`;

export const SelectorValueInput = styled(ValueInput)`
  padding-right: 40px;
`;

export const RetargetButton = styled(Button)`
  ${({ theme }) => css`
    border: none;
    position: absolute;
    right: 2px;
    top: 2px;
    height: 20px;
    width: 20px;
    padding: 14px;

    // the target SVG has a black stroke we need to cancel

    svg > path {
      fill: ${theme.colors.GlitterGrayL10};
      stroke: ${theme.colors.GlitterGrayL10};
    }

    &:hover {
      border-color: unset;
      background-color: unset;

      svg > path {
        fill: ${theme.colors.AquaTeal};
        stroke: ${theme.colors.AquaTeal};
      }
    }
  `}
`;
